import styled from 'styled-components';

import { Paper } from '@material-ui/core';

export const ContainerBase = styled(Paper)`
  padding: 20px;
  ${({ maxwidth }) => maxwidth && `max-width: ${maxwidth}px`}
`;

export const Centered = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h1`
  margin: 20px 0;
`;
